function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { StyledIcon } from '../StyledIcon';
export var Telegram = function Telegram(props) {
  return React.createElement(StyledIcon, _extends({
    viewBox: "0 0 40 40",
    a11yTitle: "Telegram"
  }, props), React.createElement("path", {
    d: "m34.3 10.23-4.34 20.47c-.33 1.45-1.18 1.8-2.4 1.12l-6.62-4.87-3.19 3.07c-.35.35-.65.65-1.33.65l.48-6.74 12.26-11.08c.53-.48-.12-.74-.83-.26l-15.16 9.54-6.53-2.04c-1.42-.44-1.45-1.42.3-2.1l25.52-9.83c1.19-.44 2.23.26 1.84 2.07z"
  }));
};